import { Lock } from "lucide-react";
import { DIMENSIONI } from "@/data/simulatorQuestions";
import { ArchetypeGlyph } from "@/components/candidati/archetipi/ArchetypeGlyph";

const nameOf = (sigla) => DIMENSIONI.find((d) => d.sigla === sigla).nome;
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const ArchetypeCard = ({ id, archetype }) => (
  <article tabIndex={0} className="arch-card glass h-full rounded-2xl border p-6 flex flex-col" aria-label={archetype.nome} data-testid={`archetype-card-${id}`}>
    <ArchetypeGlyph dims={archetype.dimensioni} />
    <h3 className="mt-5 font-bold tracking-[-0.02em] text-lg text-white">{archetype.nome}</h3>
    <div className="mt-3 flex flex-wrap gap-1.5">
      {archetype.dimensioni.map((d) => (
        <span key={d} className="rounded-full border border-[#00e5ff]/30 bg-[#00e5ff]/[0.06] px-2.5 py-0.5 text-[11px] font-medium text-cyan">
          {nameOf(d)}
        </span>
      ))}
    </div>
    <p className="mt-4 text-sm leading-relaxed text-titanium">{cap(archetype.descrizione)}</p>
    <p className="mt-auto pt-5 flex items-center gap-2 text-[11px] tracking-[0.05em] text-[#5b6068]">
      <Lock className="h-3 w-3 shrink-0" /> Punti di forza completi nel test
    </p>
  </article>
);
